import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from './baseTypes';
import { getProviderCptRates } from '@uplift/api';
import { providerQueryKeys } from './provider/providerQueryKeys';

export const useProviderCptRates = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: providerQueryKeys.cptRates(providerId),
    queryFn: async () => {
      try {
        const allProviderCptRates = await getProviderCptRates(providerId);

        return allProviderCptRates.data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    ...opts,
  });
};
